$(document).ready(function(){  
  let oldRoute = document.referrer;
  let routeMainPage = location.host;
  if(oldRoute.includes("collections")){
   	let arrayRoute = oldRoute.split("/");
    if(arrayRoute.length > 5){
    	$("#colección-ruta").html("<a href='https://"+routeMainPage+"/collections/"+arrayRoute[arrayRoute.length -2]+"'>"+arrayRoute[arrayRoute.length -2].replace(/-/gm, " ").replace(/\?page=[0-9]/gm, "").replace(/[0-9]/gm, "").replace("relojes", "")+"</a> <img src='https://cdn.shopify.com/s/files/1/0351/6602/7916/files/Right_pointing_single_angle_quotation_mark_1.svg?v=1640711391' style='margin: 0px 5px;width: 5px;'/> <a href='https://"+routeMainPage+"/collections/"+arrayRoute[arrayRoute.length -1]+"'>"+ arrayRoute[arrayRoute.length -1].replace(/-/gm, " ").replace(/\?page=[0-9]/gm, "").replace(/[0-9]/gm, "") +"</a>");
    }else{
        console.log(arrayRoute[arrayRoute.length -1])
		$("#colección-ruta").html("<a href="+oldRoute+">"+arrayRoute[arrayRoute.length -1].replace(/-/gm, " ").replace(/\?page=[0-9]/gm, "").replace(/[0-9]/gm, "")+"</a>");
    }
  }else{
      if(oldRoute == "https://"+routeMainPage+"/"){	
          $("#colección-ruta").html("").parent().css("display", "none");		
      }
  }  
})   

/*$(function(){
//     $('#slider div:gt(0)').css("opacity","0");
  setInterval(function(){
    $('#slider div:first-child').animate({opacity: 0}, {duration: 500})
    .next('div').animate({opacity: 1}, {duration: 1000})
    .end().appendTo('#slider');
  }, 5000);
});*/


$(function () {
  var needHelp = $("#data_sheet > div div:last-child .panel-faq:last-child p");
  needHelp.append('<span><strong><a href="https://api.whatsapp.com/send/?phone=573224992346&text&app_absent=0" target="_blank"> aquí</a></strong></span>');

});

 
